import { createAction, props } from '@ngrx/store';
import { UserInformation } from './user-information';
import { Account } from '@rci/self-serve-fido/state/user-information/account';

export const LoadUserInformation = '[Global] Load User Information From Cookie';
export const LoadUserInformationSuccess = '[Global] Load User Information From Cookie Success';
export const ResetUserInformation = '[Global] Reset User Information';
export const UpdateAccountsList = '[Global] Update Accounts List';
export const UpdateSelectedAccountNumber = '[Global] Update Selected Account Number';
export const UpdateSelectedSubscriberNo = '[Global] Update Selected Subscriber Number';
export const UpdateUserInformation = '[Global] Update User Information';

export const loadUserInformation = createAction(LoadUserInformation);
export const loadUserInformationSuccess = createAction(
  LoadUserInformationSuccess,
  props<{ userInfo: UserInformation }>(),
);
export const resetUserInformation = createAction(ResetUserInformation);
export const updateAccountsList = createAction(UpdateAccountsList, props<{ accounts: Account[] }>());
export const updateSelectedAccountNumber = createAction(
  UpdateSelectedAccountNumber,
  props<{ accountNumber: string }>(),
);
export const updateSelectedSubscriberNo = createAction(UpdateSelectedSubscriberNo, props<{ subscriberNo: string }>());
export const updateUserInformation = createAction(UpdateUserInformation, props<{ userInfo: UserInformation }>());
